export const isMobile = () =>
  /Android|iPhone|iPad|Tablet/i.test(navigator.userAgent);